import { FileProviderViewState, getFileProviders } from 'owa-fileprovider-store';
import { createAttachmentFromLink } from 'owa-link-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { trace } from 'owa-trace';
import { getSharingLinkInfo } from 'owa-link-data';

export function getProviderAndAttachLinkAsCopy(linkId: string) {
    const sharingLink = getSharingLinkInfo(linkId);
    const providerId = getProviderId(getFileProviders(), sharingLink.providerType);

    if (!isNullOrWhiteSpace(providerId)) {
        createAttachmentFromLink(linkId, providerId, false /* isTryAgain */);
    }
}

function getProviderId(
    providers: FileProviderViewState[],
    providerType: AttachmentDataProviderType
) {
    for (let i = 0; i < providers.length; i++) {
        if (providers[i].type === providerType) {
            return providers[i].model.Id;
        }
    }

    trace.error(
        `createAttachmentFromLink: Could not get ${providerType.toString()} provider ID. File will not upload.`
    );

    return '';
}
